import { useEffect, useRef } from "react";

// Escape закрывает верхний слой панели: открытое окно, а если окон нет —
// открытый чат в «Сообщениях».
//
// Каждое окно, пока открыто, регистрирует здесь своё закрытие, и Escape
// вызывает только верхнее: открытое последним, а окна — всегда выше чата.
// Одно нажатие закрывает одно окно, а не все разом, и чат под окном остаётся
// открытым. Если окно сейчас закрыть нельзя (идёт публикация, сохранение),
// его обработчик просто ничего не делает — Escape не проваливается к окну
// или чату под ним.
//
// Всплывающие меню и выпадающие списки закрываются своими обработчиками и
// вызывают preventDefault: тогда слой не трогается — первый Escape закрывает
// меню, следующий — окно. Чтобы увидеть их решение, обработка откладывается
// до конца рассылки события.

export const ESCAPE_PRIORITY_CHAT = 0;
export const ESCAPE_PRIORITY_MODAL = 10;

const layers = [];
let nextOrder = 0;
let installed = false;

const topLayer = () => {
  let top = null;
  for (const layer of layers) {
    if (!top || layer.priority > top.priority || (layer.priority === top.priority && layer.order > top.order)) {
      top = layer;
    }
  }
  return top;
};

const handleKeyDown = (event) => {
  if (event.key !== "Escape" || event.isComposing) return;
  setTimeout(() => {
    if (event.defaultPrevented) return;
    const layer = topLayer();
    if (layer) layer.handlerRef.current?.();
  }, 0);
};

const install = () => {
  if (installed || typeof window === "undefined") return;
  installed = true;
  window.addEventListener("keydown", handleKeyDown);
};

export const useEscapeLayer = (active, onEscape, priority = ESCAPE_PRIORITY_MODAL) => {
  const handlerRef = useRef(onEscape);
  handlerRef.current = onEscape;
  useEffect(() => {
    if (!active) return undefined;
    install();
    const layer = { handlerRef, priority, order: nextOrder++ };
    layers.push(layer);
    return () => {
      const index = layers.indexOf(layer);
      if (index >= 0) layers.splice(index, 1);
    };
  }, [active, priority]);
};
